import { isRTL } from '../settings'

export const warningMarkup = () =>
  isRTL()
    ? `<h2>لطفا تگ اسکریپت را دقیقا مطابق آنچه در فرم ساز اشاره شده است در سایت خود قرار دهید</h2>`
    : '<h2>Please make sure that the &lt;script&gt; tag is exactly the same as in the form builder</h2>'

const styles = `
 direction: rtl;
 padding: 20px;
 color: red;
 border: 2px solid red;
 text-align: center;
 font-family: "dana";
 `

export default function createWarningMarkup(wrapperElementId) {
  const warningWrapper = document.createElement('div')
  warningWrapper.id = wrapperElementId
  warningWrapper.style.cssText = styles
  warningWrapper.innerHTML = warningMarkup()
  document.body.appendChild(warningWrapper)
}
